import React, { useState, useEffect } from "react";
import "./deathDashboard.css";
import addIcon from "../../assets/images/DeathModuleNew/addIcon.png";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setActiveStep } from "../../redux/slices/loginSlice";
import Loader from "../../components/styled-components/loader/loader";
import protectedImg from "../../assets/images/DeathModuleNew/protected.svg";
import DEATH_API from "../../apis/death.api";

export const LitigationDashboard = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [litigationList, setLitigationList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    console.log("calling api");
    if (props.role !== "trustee") {
      getLitigationList();
    }
  }, []);
  const getLitigationList = async () => {
    try {
      (async () => {
        setLoading(true);
        const ID = localStorage.getItem("accessId");

        let data = await DEATH_API.fetchLitigation(ID);
        setLoading(false);
        if (data && data.data) {
          setLitigationList(data.data);
        }
      })();
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        background: "white",
        borderRadius: "8px",
        padding: "1rem",
        marginBottom: "1rem",
        height: "47%",
        cursor: "pointer",
        pointerEvents: props.role === "trustee" ? "none" : "",
        opacity: props.role === "trustee" ? "0.5" : "1",
      }}
      onClick={() => {
        dispatch(setActiveStep(11));
        history.push("/protector/death");
      }}
    >
      {" "}
      <div
        className="cardHeading"
        style={{
          marginTop: "8px",
          marginBottom: "8px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        LITIGATION
        <div className="uploadButtons" style={{ width: "20px" }}>
          {" "}
          <div className="upload" style={{ width: "20px", height: "20px" }}>
            <img
              src={addIcon}
              width={12}
              height={12}
              style={{ width: "12px", height: "12px" }}
              alt="addicon"
            ></img>
          </div>
        </div>
      </div>
      <div
        style={{
          height: "16rem",
          overflowY: "auto",
          display: "flex",
          // justifyContent: "center",
          flexDirection: "column",
        }}
      >
        {props.role !== "trustee" ? (
          <React.Fragment>
            {litigationList && litigationList.length > 0 ? (
              litigationList.map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #E8E9FF",
                    marginTop: "1rem",
                    marginBottom: "8px",
                    paddingBottom: "8px",
                  }}
                >
                  <div className="checkListName">{item.name}</div>
                  <div className="emailStatus">
                    {item.result ? item.result : "N/A"}
                  </div>
                </div>
              ))
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontWeight: "700",
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  marginTop:"2rem",
                }}
              >
                No Record to Show
              </div>
            )}
          </React.Fragment>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "700",
              fontFamily: "Poppins",
              fontSize: "14px",
              flexDirection: "column",
              marginTop:"2rem",
            }}
          >
            This Information will be available you soon!
            <img
              src={protectedImg}
              style={{ width: "50px", height: "50px", marginTop: "8px" }}
              alt="protectedImg"
            ></img>
          </div>
        )}
      </div>
    </div>
  );
};
